var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('set-receiving-wallet-action',{scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('div',_vm._g({},on),[(_vm.show)?_c('v-alert',{attrs:{"outlined":"","dense":"","border":"left","type":"warning"}},[_vm._v(" "+_vm._s(_vm.$t("hfox.set-receiving-wallet"))+" "),_c('strong',[_vm._v(" "+_vm._s(_vm.$t("hfox.set-wallet"))+" ")])]):_vm._e()],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }